exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".text_content{max-width:60%;padding:12px;border-radius:6px;overflow-x:hidden}.text_content p{word-break:break-all;line-height:24px}.text_content .emoji{width:24px;height:24px;vertical-align:middle;display:inline-block}\n", ""]);

// exports
